import type { FC, ReactNode } from 'react'
import type { LayoutProps } from '@/types'

import { Header } from '@/components/generals/header'
import { Footer } from '@/components/generals/footer'
import { WhatsappFloat } from '@/components/generals/whatsapp-float'

export const Layout: FC<LayoutProps> = ({ children }): ReactNode => {
    return (
        <div className='flex min-h-screen flex-col'>
            <a
                href='#main'
                className='sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] focus:rounded-full focus:bg-brand-charcoal focus:px-5 focus:py-2.5 focus:text-sm focus:font-semibold focus:text-brand-white'
            >
                Skip to content
            </a>

            <Header />

            <main id='main' className='flex-1'>
                {children}
            </main>

            <Footer />
            <WhatsappFloat />
        </div>
    )
}
